// src/styles/GlobalStyle.ts
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Roboto', sans-serif;
    background-color: #f5f5f5;
    color: #333;
  }

  /*
    테이블 헤더 좌우정렬 통일 (전부 가운데).
    antd는 컬럼의 align 값을 헤더/본문 셀 양쪽에 인라인 style로 넣기 때문에
    헤더만 가운데로 맞추려면 !important가 필요하다. 본문 셀 정렬은 그대로 둔다.
  */
  .ant-table-thead > tr > th {
    text-align: center !important;
  }

  .MuiTableHead-root .MuiTableCell-root {
    text-align: center !important;
  }
`;

export const myTheme = {
  colors: {
    primary: "#546E7A",
    primaryHover: "#889e93",
    secondary: "#03dac6",
    background: "#f5f5f5",
    text: "#333",
    border: "#e0e0e0",
    connectingBlue: {
      default: "#6D9EDB",
      hover: "#78ABEA",
      focused: "#66A0E8",
      pressed: "#E06E1C",
      disabled: "#CCD5DF",
    },
    furryBrown: {
      default: "#C47B3E",
      hover: "#DB9052",
      focused: "#C27535",
      pressed: "#B76C2E",
      disabled: "#D7C6B2",
    },
    happierYellow100: {
      default: "#FFD217",
      hover: "#FFE269",
      focused: "#FCC505",
      pressed: "#F0B214",
      disabled: "#E0DCD2",
    },
    happierYellow200: {
      default: "#FFE483",
      hover: "#FFECA6",
      focused: "#FFE06F",
      pressed: "#F5CF4A",
      disabled: "#E7E4DA",
    },
    knolloBlue: {
      default: "#093DBF",
      hover: "#2560F0",
      focused: "#0431FA",
      pressed: "#072AC8",
      disabled: "#E28848",
    },
    grayScale100: {
      default: "#221C15",
      hover: "#332E27",
      focused: "#1A140F",
      pressed: "#0D0905",
      disabled: "#AEAAA5",
    },
    grayScale200: {
      default: "#454441",
      hover: "#54534F",
      focused: "#2D2D2C",
      pressed: "#212120",
      disabled: "#BFBEBE",
    },
    grayScale300: {
      default: "#6A6A67",
      hover: "#767673",
      focused: "#646461",
      pressed: "#5E5E5A",
      disabled: "#B7B7B6",
    },
    grayScale400: {
      default: "#9A9A95",
      hover: "#A6A6A0",
      focused: "#9A9A95",
      pressed: "#91918B",
      disabled: "#C5C5C4",
    },
    grayScale500: {
      default: "#BFBEBA",
      hover: "#CAC9C4",
      focused: "#B8B7B3",
      pressed: "#AFAEAA",
      disabled: "#D0D0CF",
    },
    grayScale600: {
      default: "#DAD9D7",
      hover: "#E4E3E1",
      focused: "#D5D3CF",
      pressed: "#CDCCC8",
      disabled: "#D8D8D7",
    },
    grayScale700: {
      default: "#E9E8E5",
      hover: "#EFEEEB",
      focused: "#E3E2DF",
      pressed: "#DCDBD9",
      disabled: "#F3F2EF4d",
    },
    grayScale800: {
      default: "#F8F7F5",
      hover: "#FFFFFF",
      focused: "#E7E9EC",
      pressed: "#DDDFE2",
      disabled: "#F1F3F64d",
    },
    grayScale900: {
      default: "#FFFFFE",
      hover: "#FFFFFF",
      focused: "#F5F5F5",
      pressed: "#EBEBEB",
      disabled: "#ffffffb3",
    },
    black: "#000000",
    white: "#FFFFFF",
    dimmed: "#000000b3",
    dimmed100: "#00000050",
    dimmed200: "#00000020",
    systemSafe: {
      default: "#0B9115",
      hover: "#1FA529",
      focused: "#01870B",
      pressed: "#007D01",
      disabled: "#0b91154d",
    },
    systemWarning: {
      default: "#E9A802",
      hover: "#FDBC16",
      focused: "#DF9E00",
      pressed: "#D59400",
      disabled: "#e9a8024d",
    },
    systemDangerous: {
      default: "#C62828",
      hover: "#DA3C3C",
      focused: "#BC1E1E",
      pressed: "#B21414",
      disabled: "#c628284d",
    },
  },
  fonts: {
    main: "'Roboto', sans-serif",
  },
  breakpoints: {
    mobile: "600px",
    tablet: "960px",
    desktop: "1280px",
  },
};
